import { lazy } from "react";
import { getRoute } from "util/react";

const AllReviewsRoute = getRoute(
  { fullPath: "/:locale?/reviews" },
  "reviews",
  lazy(() => import("./index")),
  null,
);

export default AllReviewsRoute;
